var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeperator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87472 15.5025C4.79246 15.503 4.71092 15.4872 4.63478 15.4561C4.55863 15.425 4.48937 15.3792 4.43097 15.3213C4.37239 15.2632 4.32589 15.1941 4.29416 15.1179C4.26243 15.0417 4.24609 14.96 4.24609 14.8775C4.24609 14.795 4.26243 14.7133 4.29416 14.6372C4.32589 14.561 4.37239 14.4919 4.43097 14.4338L9.53722 9.32755C9.88834 8.97598 10.0856 8.49942 10.0856 8.00255C10.0856 7.50567 9.88834 7.02911 9.53722 6.67755L4.43097 1.57131C4.31328 1.45362 4.24716 1.29399 4.24716 1.12756C4.24716 0.961118 4.31328 0.801497 4.43097 0.683807C4.54866 0.566117 4.70828 0.5 4.87472 0.5C5.04116 0.5 5.20078 0.566117 5.31847 0.683807L10.4247 5.79005C10.7157 6.08034 10.9466 6.42518 11.1042 6.80484C11.2617 7.1845 11.3428 7.5915 11.3428 8.00255C11.3428 8.41359 11.2617 8.8206 11.1042 9.20026C10.9466 9.57991 10.7157 9.92476 10.4247 10.215L5.31847 15.3213C5.26007 15.3792 5.19081 15.425 5.11466 15.4561C5.03851 15.4872 4.95697 15.503 4.87472 15.5025Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeperator);
export default __webpack_public_path__ + "static/media/seperator.47a2c884df1d161a889bab3a0f890924.svg";
export { ForwardRef as ReactComponent };